import React from 'react';
import clsx from 'clsx';

import styles from './ContentContainer.scss';

class ContentContainer extends React.Component {
  static defaultProps = {
    component: 'div',
  };

  render() {
    const {
      component: Component,
      children,
      className,
      ...restProps
    } = this.props;
    const css = clsx(className, styles.container);

    return (
      <Component {...restProps} className={css}>
        {children}
      </Component>
    );
  }
}

export default ContentContainer;
